import { Modal } from "react-overlays";
import { usePdf } from "../hooks/usePdf";
import Icon from "./icons";

const PdfButton = ({ data, className, children }) => {
  const { downloadPdf, loading, error, clearError } = usePdf();
  return (
    <>
      <button
        onClick={() => downloadPdf(data)}
        className={className}
        disabled={loading}
      >
        {loading && (
          <span
            className="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
        )}{" "}
        {children}
      </button>
      {error && (
        <Modal
          show={!!error}
          onHide={clearError}
          className="modal__internal d-flex flex-column"
          aria-labelledby="modal-label"
        >
          <>
            <button
              aria-label="close"
              className="modal__close"
              onClick={clearError}
            >
              <Icon className="ms-2" name="xmark" />
            </button>
            <div className="modal__header">
              <h3>Impossibile scaricare il PDF</h3>
            </div>
            <div
              className="modal__body"
              dangerouslySetInnerHTML={{
                __html: error,
              }}
            ></div>
          </>
        </Modal>
      )}
    </>
  );
};

export default PdfButton;
